<template>
  <div class="d-flex w-100 flex-column flex-grow-1 flex-shrink-0 h-100">
    <h4 class="h5 text-exitos mb-2 d-block" v-text="title" />

    <div
      v-if="!disableSearch"
      :data-state="stateSearch"
      class="mb-2 position-relative"
    >
      <b-form-input
        v-model="modelValue"
        :disabled="disabled"
        :placeholder="placeholder"
        class="mb-0"
      />
      <font-awesome-icon
        @click.stop="clearSearch"
        :icon="iconSearch"
        class="icon-close"
        size="xs"
      />
    </div>

    <b-list-group
      v-if="listGroup"
      class="overflow-auto"
      :style="{ 'max-height': disableSearch ? '21rem' : '18rem' }"
    >
      <slot />
    </b-list-group>
    <slot v-else />

    <div class="flex-grow-1 flex-shrink-1" />
    <p
      v-if="showCount"
      class="small text-muted border-top pt-2 mt-4 mb-0"
      v-text="countLabel"
    />
  </div>
</template>

<script>
import { stripAccents } from "@/helpers/functions/StringHelpers";
import { useDebounceFn } from "@vueuse/core";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "SelectMultiMunicipioSection",
  props: {
    value: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Pesquisar...",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    listGroup: {
      type: Boolean,
      default: true,
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    countLabel: {
      type: String,
      default: "",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  emits: ["input"],
  setup(props, { emit }) {
    const canDebouncedFn = useDebounceFn((value) => {
      emit("input", value);
    }, 450);

    const modelValue = computed({
      get() {
        return props.value;
      },
      set(value) {
        canDebouncedFn(value);
      },
    });

    const existsSearch = computed(
      () => stripAccents(modelValue.value).length > 0
    );

    const stateSearch = computed(() =>
      existsSearch.value ? "search" : "empty"
    );

    const iconSearch = computed(() =>
      existsSearch.value ? "xmark" : "magnifying-glass"
    );

    function clearSearch() {
      if (!existsSearch.value) return;

      canDebouncedFn("");
    }

    return {
      modelValue,
      existsSearch,
      stateSearch,
      iconSearch,

      clearSearch,
    };
  },
});
</script>
<style scoped lang="scss">
.icon-close {
  position: absolute;
  top: 50%;
  right: 0.25rem;
  height: 1rem;
  padding: 0.5rem;
  width: 1rem;
  border-radius: 100vw;
  transform: translateY(-50%);
  color: var(--active-color);
  cursor: var(--active-cursor, default);
}

[data-state="empty"] {
  --active-color: rgba(var(--default-rgb), 0.25);
}

[data-state="search"] {
  --active-cursor: pointer;
  --active-color: var(--danger);
}
</style>
